import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	SSID_SCHEDULE_FILTER_EVENT,
	SSID_SCHEDULE_FOCUS_EVENT,
	SSID_SCHEDULE_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['profile.ssid_schedules']);

/**
 * Open the SSID Schedule section.
 * @return {Promise<void>} completion acknowledgement
 */
export function openSsidScheduleSection() {
	return openResourceSection(
		SSID_SCHEDULE_SECTION_EVENT,
		'profile.ssid_schedules',
		SECTIONS,
	);
}

/**
 * Apply an SSID Schedule query.
 * @param {string} query Schedule query
 * @return {Promise<void>} completion acknowledgement
 */
export function applySsidScheduleFilter(query) {
	if (typeof query !== 'string' || !query.trim()) {
		return Promise.reject(new Error('invalid_ssid_schedule_filter'));
	}
	return dispatchAcknowledgedEvent(SSID_SCHEDULE_FILTER_EVENT, {
		query: query.trim(),
		resource: 'schedule',
	});
}

/**
 * Focus a resolved SSID Schedule.
 * @param {string} entityId opaque Schedule identifier
 * @return {Promise<void>} completion acknowledgement
 */
export function focusSsidSchedule(entityId) {
	if (typeof entityId !== 'string' || !entityId) {
		return Promise.reject(new Error('invalid_ssid_schedule_entity'));
	}
	return dispatchAcknowledgedEvent(SSID_SCHEDULE_FOCUS_EVENT, {
		entityId,
		resource: 'schedule',
	});
}
